export default "__VITE_ASSET__BppEP48q__"